/* eslint-disable react/no-danger */
import type { FC } from 'react';
import Helmet from 'react-helmet';

import { gtmData } from 'constants/gtm';

import { script } from './const/script';

const GTM: FC = () => {
    return (
        <Helmet>
            <script dangerouslySetInnerHTML={{ __html: script }} />
            <script async src={`https://www.googletagmanager.com/gtm.js?id=${gtmData.id}`} />
        </Helmet>
    );
};

export default GTM;
